//core
import React, {useCallback, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, Divider } from "@mui/material";

//icons
import { MoreVert, Edit, Visibility, Delete } from "@mui/icons-material";

//styles
import { useStyles } from "./styles";

//routes
import routes from "../../../../../../../navigation/routes";

//hooks
import { usePermissions } from "../../../../../../../store/common/configuration/usePermissions";

//components
import MuiModal from "../../../../../../UI/MuiModal";
import { itemListData } from "../../../../../../common/TableData";
import DeleteDeal from "../../../DeleteDeal";

export interface ICardMenuProps {
  data: itemListData;
}

const CardMenu: React.FC<ICardMenuProps> = ({
  data
}): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { hasPermissions } = usePermissions();
	let history = useNavigate();

	const hasDetails = hasPermissions(["api3.admin.subaffiliatedealcontroller.show"]);
	const hasDelete = hasPermissions(["api3.admin.subaffiliatedealcontroller.delete"]);
	const hasEdit = hasPermissions(["api3.admin.subaffiliatedealcontroller.update"]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, [setAnchorEl]);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  },[setAnchorEl]);

	const handleToggleShowDeleteModal = useCallback((state: boolean) => {
		setShowDeleteModal(state);
		handleClose();
	}, [setShowDeleteModal]);

	const handleShowDetailsDeal = useCallback(() => {
		history(routes.admin.sub_aff_deals_v2.details.replace(':id', `${data.id}`));
	}, [data.id]);

	const handleEditDeal = useCallback(() => {
		history(routes.admin.sub_aff_deals_v2.edit.replace(':id', `${data.id}`));
	}, [data.id]);

  return (
    <>
      <Button
        className={`aff-card-menu ${styles.button} ${ open ? styles.active : ''}`}
        color="secondary"
        onClick={handleClick}
        id="aff-card-menu"
        aria-controls={open ? 'basic-card-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreVert className={styles.icon} />
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'tracker-card-menu',
          sx: {
            paddingTop: 0,
            paddingBottom: 0,
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
	      {hasDetails && (
		      <MenuItem
			      onClick={handleShowDetailsDeal}
		      >
			      <Visibility className={styles.icon} sx={{ marginRight: '16px' }} />
			      {t("common.buttons.details")}
		      </MenuItem>
	      )}
	      {hasDetails && <Divider className={styles.divider}/>}

	      {hasEdit && (
		      <MenuItem
			      onClick={handleEditDeal}
			      disabled={(data.hasOwnProperty('isReadOnly') && data?.isReadOnly)}
		      >
			      <Edit className={styles.icon} sx={{ marginRight: '16px' }} />
			      {t("common.buttons.edit")}
		      </MenuItem>
	      )}
	      {hasEdit && <Divider className={styles.divider}/>}

        {hasDelete && (
          <MenuItem
	          onClick={() => handleToggleShowDeleteModal(true)}
	          disabled={(data.hasOwnProperty('isReadOnly') && data?.isReadOnly)}
          >
            <Delete className={styles.icon} sx={{ marginRight: '16px' }} />
	          {t("common.buttons.delete")}
          </MenuItem>
        )}

      </Menu>

	    {hasDelete && (<MuiModal
		    width={472}
		    open={showDeleteModal}
		    closeOnOutside={false}
		    setToggleModal={handleToggleShowDeleteModal}
	    >
		    <DeleteDeal
			    id={data.id}
			    setToggleModal={handleToggleShowDeleteModal}
		    />
	    </MuiModal>)}
    </>
  );
};

export default CardMenu;
